import React, { Component } from 'react';
import { withRouter } from 'react-router';

import { getContent } from '../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../constants/routerConstant';
import API_AUTHENTICATION from '../../api/apiAuthentication';
import NexcareImg from '../../assets/images/nexcare-logo-out.svg';

class OutsideLogo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            version: ''
        }
    }

    componentDidMount() {
        this._isMounted = true;

        API_AUTHENTICATION.getVersionRelease()
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        version: getContent(res).version_release
                    });
                }
            })
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleClickLogo = () => {
        this.props.history.push(ROUTER_CONSTANT.LOGIN);
    }

    render() {
        return (
            <div className="absolute w-60 left-48 top-14">
                <img src={NexcareImg} alt="NexCare Logo" className="cursor-pointer" id="btnlogo" onClick={() => this.handleClickLogo()} />
                <div className="text-right text-xs font-bold text-bluedarken">Version {this.state.version}</div>
            </div>
        );
    }
}

export default withRouter(OutsideLogo);